import React from 'react';

import { Link, withRouter } from 'react-router-dom';

import http from 'Demora/http';

import ReduxConnect from 'Demora/redux-connect';

import DMForm from 'Demora/DMForm3';

class Login extends React.Component {
	constructor(props, context) {
		super(props);

		const usp = new URLSearchParams(props.location.search);

		this.state = {
			error:
				usp.get('reason') ??
				(usp.get('status') === 'failed'
					? 'The login linked was invalid. This is normally because the login link was sent more than 15 minutes ago, or you have already used the link once.'
					: null),
			loaded: false,
			twofa: false,
			email: null,
			password: null,
			remember: null,
			stage: null,
			k2: null,
		};
	}

	componentDidMount() {
		if (this.props.user.id) {
			return this.redirect();
		}

		this.setState({
			loaded: true,
		});
	}

	componentWillUnmount() {
		this.unmounted = true;
	}

	handleEmail1 = (data) => {
		const state = this.state;

		const email = data.email;

		localStorage.setItem('currentTeam', '{}');

		return http
			.post('/data/login/email', {
				email,
			})
			.then((data) => {
				if (!data.rufP || this.unmounted) {
					return;
				}

				const st = {
					email,
					k2: data.k2,
					stage: 'select',
				};

				st.error = null;

				if (data.error) {
					st.error = data.error;
				}

				this.setState(st);
			});
	};

	handleShowPassword = () => {
		this.setState({
			stage: 'password',
		});
	};

	handleReset = () => {
		this.setState({
			stage: null,
		});
	};

	handlePassword = (data) => {
		const state = this.state;

		const email = state.email;
		const password = data.password;
		const k2 = state.k2;

		return http
			.post('/data/login/password', {
				email,
				password,
				k2,
			})
			.then((data) => {
				if (data.user && data.user.id) {
					this.registerUser(data.user);
					return true;
				} else if (data.twofa) {
					this.setState({
						error: '',
						password,
						stage: '2fa',
					});
					return true;
				} else {
					this.setState({
						error:
							'Your email address or password were not recognised, please check and try again.',
						stage: '',
					});
					return true;
				}
			});
	};

	handle2FA = (data) => {
		const code = data.code;

		const state = this.state;

		return http
			.post('/data/login/twofa', {
				email: state.email,
				password: state.password,
				k2: state.k2,
				code: code,
				remember: data.remember,
			})
			.then((data) => {
				if (data.user && data.user.id) {
					this.registerUser(data.user);
					return true;
				} else {
					if (!data.error) {
						this.setState({
							email: null,
							password: null,
							twofa: null,
							error:
								'Either the code was incorrect or the code was sent to you more than 5 minutes ago, please try again. You must use the code within 5 minutes.',
							remember: null,
						});
					}
				}
			});
	};

	handleMagic = () => {
		const redi = new URLSearchParams(this.props.location.search).get('redi');

		return http
			.post('/data/login/link', {
				email: this.state.email,
				redirect: redi,
				k2: this.state.k2,
			})
			.then((data) => {
				if (!data.rufP || this.unmounted) {
					return;
				}
				this.setState({
					stage: 'magic',
				});
			});
	};

	redirect() {
		const redi =
			new URLSearchParams(this.props.location.search).get('redi') ?? '/home';
		this.props.history.push('/login/multi?redi=' + encodeURIComponent(redi));
	}

	registerUser(user) {
		const teamId =
			user && user.currentTeam && user.currentTeam.id ? user.currentTeam.id : 0;

		this.props.dispatch({
			type: 'STORE_USER',
			user: user,
		});

		this.redirect();
	}

	emailField = () => {
		return {
			inputType: 'custom',
			render: ({ control, deleteMultiField, element, key, watches }) => {
				return [
					<label key={0} className='col-form-label col-md-4'>
						<span>Email</span>
					</label>,
					<div key={1} className='col-md-8' onClick={this.handleReset}>
						<div className='form-control'>{this.state.email}</div>
					</div>,
				];
			},
		};
	};

	render() {
		const state = this.state;

		if (!state.loaded) {
			return null;
		}

		return (
			<div className='container'>
				<div className='row'>
					<div className='col-md-8 offset-md-2'>
						<div className='card'>
							<div className='card-header'>Login</div>
							<div className='card-body'>
								<div className='card-text'>
									{!state.error ? (
										''
									) : (
										<div className='text-center alert alert-danger'>
											{state.error}
										</div>
									)}

									{!state.stage ? (
										<div>
											<DMForm
												key='1'
												form={{
													fields: [
														{
															name: 'email',
															label: 'Email',
															placeHolder: 'Email address',
															inputType: 'email',
															dataType: 'string',
															helpMessage: '',
															required: true,
															value: state.email,
														},
													],
													button: {
														text: 'Login',
														class: 'btn-primary',
														position: 'right',
													},
													submit: this.handleEmail1,
													clearFormAfterSubmit: true,
												}}
											/>

											<div className='row'>
												<div className='col-md-6 text-center'>
													<Link to='/signup'>Need an account?</Link>
												</div>
												<div className='col-md-6 text-center'>
													<Link to='/password/reset'>Forgotten password</Link>
												</div>
											</div>
										</div>
									) : state.stage === 'select' ? (
										<div>
											<div className='text-center alert alert-warning'>
												Choose one of the options below. You can either choose
												to enter your password, or receive a link to your email
												address to login.
											</div>
											<div>
												<button
													className='btn btn-primary btn-block mb-3'
													onClick={this.handleMagic}
												>
													Login via an email link
												</button>
												<button
													className='btn btn-primary btn-block'
													onClick={this.handleShowPassword}
												>
													Enter your password
												</button>
											</div>
										</div>
									) : state.stage === 'password' ? (
										<div>
											<DMForm
												key='2'
												form={{
													fields: [
														this.emailField(),
														{
															name: 'password',
															label: 'Password',
															placeHolder: 'Password',
															inputType: 'password',
															dataType: 'string',
															helpMessage: '',
															required: true,
															value: '',
														},
													],
													button: {
														text: 'Login',
														class: 'btn-primary',
														position: 'right',
													},
													submit: this.handlePassword,
													clearFormAfterSubmit: true,
												}}
											/>
											<div className='row'>
												<div className='col-md-6 text-center'></div>
												<div className='col-md-6 text-center'>
													<Link to='/password/reset'>Forgotten password</Link>
												</div>
											</div>
										</div>
									) : state.stage === '2fa' ? (
										<div>
											<div className='text-center alert alert-danger'>
												To help protect your login details, we have just sent
												you an email to {this.state.email} with a security code.
												Enter the code below to login.
											</div>

											<DMForm
												key='3'
												form={{
													fields: [
														this.emailField(),
														{
															name: 'code',
															label: 'Code',
															placeHolder: 'Your code',
															inputType: 'string',
															dataType: 'string',
															helpMessage: '',
															maxLength: 6,
															required: true,
															additional_params: {
																autoComplete: 'one-time-code',
																inputMode: 'numeric',
																pattern: '\\d{6}',
															},
														},
														{
															name: 'remember',
															label: 'Trust this computer',
															placeHolder: 'Trust',
															inputType: 'checkbox',
															dataType: 'boolean',
															helpMessage: '',
															value: true,
															required: false,
														},
														{
															inputType: 'plainText',
															name: ' ',
															helpMessage: '',
															value: (
																<div className='text-center small p-2'>
																	If you trust this computer, tick the box and
																	you won't have to enter a code again
																</div>
															),
														},
													],
													button: {
														text: 'Login',
														class: 'btn-primary',
														position: 'right',
													},
													submit: this.handle2FA,
													clearFormAfterSubmit: true,
												}}
											/>
										</div>
									) : (
										<div className='text-center'>
											If you have an account with that email address an email
											will be sent to you with a link to login.
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default withRouter(
	ReduxConnect(Login, {
		user: 'user',
	})
);
